import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';

// Services
import { SidebarService } from '../../services/sidebar.service';
import { PermissionGroupService } from '../../services/permissionGroup.service';
import { LOGO_COMUNIDAD_KIUNGO, LOGO_COMUNIDAD_KASTOR } from '../../app.service';
import { CommunityService } from '../../services/community.service';
import { AdministrationService } from '../../services/administration.service';
import { AppBase } from '../../app-base';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-sidebar-community',
  templateUrl: './sidebar-community.component.html',
  styleUrls: ['./sidebar-community.component.sass']
})
export class SidebarCommunityComponent extends AppBase implements OnInit, OnDestroy {
  // variables
  private componentDestroyed: Subject<boolean> = new Subject();
  public sidebarStatus: Boolean = true;
  public subscriptionSidebar: Subscription;
  public subscriptionRoute: Subscription;
  public communityInSession: String;
  public administration: any;
  public administrationIdentifier: any;
  public administrationId = null;
  public imageUser = null;
  public urlActive = null;
  public emailuser = null;
  public imageAdministration: String;
  public permissionUser = [];
  public logoCommunity = LOGO_COMUNIDAD_KASTOR;
  public realmUser = null;

  constructor(private _sidebarService: SidebarService,
              public router: Router,
              private _userService: UserService,
              private _administrationService: AdministrationService,
              public _communityService: CommunityService,
              public _permissionGroupService: PermissionGroupService) {
    super();
    const {administration_id, realm} = this.currentUser;
    this.administrationId = administration_id;
    this.realmUser = realm;
    this._sidebarService.changeRoute(router.url);
  }

  ngOnInit() {
    this.imageAdministration = this.getStorageItem('imageAdministration');

    if (this.realmUser === 'kiungo') {
      this.logoCommunity = LOGO_COMUNIDAD_KIUNGO;
    }

    this._userService.getUserById(this.currentUser.user_id).subscribe(user => {
      this.emailuser = user.email;
      this.imageUser = user.user_img;
    });

    if (this.currentUser.community_id) {
      this._communityService.getCommunityById(this.currentUser.community_id).subscribe(response => {
        this.communityInSession = response.community.name;
      });
    }

    this.getAdministrationSettings();

    this._administrationService.getAdministrationById(this.currentUser.administration_id)
      .subscribe(administration => {
        this.administration = administration.name;
        this.administrationIdentifier = administration.id_number;
      });

    this._permissionGroupService.userPermissionAdministration(this.administrationId)
      .takeUntil(this.componentDestroyed)
      .subscribe(
        data => {
          this.permissionUser = data;
          this.router.events.subscribe((val: any) => {
            // see also
            if (val.url) {
              this._sidebarService.changeRoute(val.url);
            }
          });
          // oyente
          this.subscriptionSidebar = this._sidebarService.observableStateSidebar$
            .subscribe(
              res => {
                this.sidebarStatus = !this.sidebarStatus;
              });
          // oyente
          this.subscriptionRoute = this._sidebarService.observableRoute$
            .subscribe(
              res => {
                this.urlActive = res;
              });
          this.changeRoute('/communities');
          // this._sidebarService.changeRoute(this.urlActive);
        },
        err => {
          console.log(err);
        });

    setTimeout(() => {
      this._sidebarService.changeRoute(this.urlActive);
    }, 1000);

    // this.permissions();

    this.observableDataAdministration();
  }

  // activamos y desactivamos sidebar
  public toggleClass(): void {
    this.sidebarStatus = !this.sidebarStatus;
  }

  // gatillamos detección cambio de ruta
  public changeRoute(route: string): void {
    this._sidebarService.changeRoute(route);
  }

  validPermission(permission) {
    const permissionValid = this.permissionUser.find(x => x === permission);
    if (permissionValid) {
      return true;
    }
    return false;
  }

  ngOnDestroy() {
    this.componentDestroyed.next(true);
    this.componentDestroyed.complete();
  }

  private getAdministrationSettings() {
    this._administrationService.getAdministrationSetting(this.administrationId)
      .subscribe(response => {

        const setting = response && response.administrationSettings &&
          response.administrationSettings.length > 0
          ? response.administrationSettings.find(s => s.administrationSettingsField.key === 'ADMINISTRATION_IMAGE')
          : null;

          if (setting) {
            this.imageAdministration = setting.value.image;
          }
      });
  }

  private observableDataAdministration() {
    this._sidebarService.observableDataAdministration$
      .subscribe(
        res => {
          this.imageAdministration = this.getStorageItem('imageAdministration');
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/sidebar-community/sidebar-community.component.ts